export const CSS_CLASS_ANIMATE_FLIGHT_CARD = "animate-flight-card";